import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  openModal: `${NAMESPACE}_CONFIG_EVENT_HTTP_HEADERS_OPEN_MODAL`,
  closeModal: `${NAMESPACE}_CONFIG_EVENT_HTTP_HEADERS_CLOSE_MODAL`,
  updateHeaders: `${NAMESPACE}_CONFIG_EVENT_HTTP_HEADERS_UPDATE_HEADERS`
};

export const actionCreators = {
  openModal: () => ({ type: actions.openModal }),
  closeModal: () => ({ type: actions.closeModal }),
  updateHeaders: (payload) => ({ type: actions.updateHeaders, payload })
};

export default {
  actions,
  actionCreators
};
